<template>
    <!-- payment overlay -->
    <div class="payment-overlay">
        <div class="mx-auto w-100 text-center f4">
            <img src="/img/be/paypal-logo.png" width="150" class="my-5"><br>
            {{$t('attendi_attimo')}} ...<br>
            {{$t('elaborazione_pagamento')}}, <br>
            {{$t('nn_chiudere_browser')}}.<br><br>
            {{$t('grazie')}}
        </div>
    </div>
</template>

<script>
export default {
    name: "IncPaymentOverlay",
}
</script>
